import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { en } from './translations/en';
import { fr } from './translations/fr';
import { pt } from './translations/pt';

export type Language = 'en' | 'fr' | 'pt';

export type Translation = typeof en;

const translations: Record<Language, Translation> = {
  en,
  fr,
  pt
};

interface I18nStore {
  language: Language;
  setLanguage: (lang: Language) => void;
}

export const useI18n = create<I18nStore>()(
  persist(
    (set) => ({
      language: 'en',
      setLanguage: (lang) => set({ language: lang })
    }),
    {
      name: 'language-storage'
    }
  )
);

// Hook pour accéder aux traductions
export function useTranslation() {
  const { language } = useI18n();
  return {
    t: (key: keyof Translation | string) => {
      const keys = key.split('.');
      let current = translations[language] as any;
      for (const k of keys) {
        if (current[k] === undefined) return key;
        current = current[k];
      }
      return current;
    },
    currentLanguage: language
  };
}